import React, { useEffect, useState } from 'react';
import CKEditor from 'ckeditor4-react';

CKEditor.editorUrl = 'ckeditor/ckeditor.js';

const Editor = (props) => {
    const [contentState, setContentState] = useState("");

    const configuraciones = {
        toolbar: [
            [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo', '-', 'Bold', 'Italic', 'Underline', '-', 'TextColor' ],
        ],
        height: 70,
        removePlugins: 'resize, elementspath',
    }

    let cambiaHtml = (e) => {
        setContentState(e.editor.getData())
    }

    let UpdState = () => {
        props.funcion(contentState)
    }

    return (
        <React.Fragment>
            <div className="text-muted" style={{fontSize: 12}}>{props.titulo}</div>
            <CKEditor
                data = {contentState}
                type = "classic"
                onChange = {cambiaHtml} 
                config = {configuraciones}
                onBlur = {UpdState}
            />
        </React.Fragment>
    )
}

export default Editor;


// WEBPACK FOOTER //
// ./src/views/WebMaster/Inicio/Editor.jsx